import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: ${COLORS.BLACK};
  color: ${COLORS.WHITE};
  min-height: 0;
  padding: 2em;
  border-radius: 4px;
  background: ${COLORS.BLACK};
  justify-content: center;
  box-shadow: inset 50px 50px 100px #000, inset -50px -50px 100px #000;
  @media (min-width: 1200px) {
    min-height: 188px;
  }
`;

const Title = styled.h2`
  font-weight: 900;
  font-size: 2.35em;
`;

export { Container, Title };
